// Product page: option chips -> variant id, exact-spec panel, delivery window, and the ZIP gate.
// The ZIP gate only confirms coverage (prototype, see ttr-zip.js). It is not regional pricing.
(function () {
  document.querySelectorAll('[data-ttr-product]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }
    var select = root.querySelector('[data-variant-select]');
    var atc = root.querySelector('[data-atc]');
    var msg = root.querySelector('[data-atc-msg]');
    var price = root.querySelector('[data-price]');
    var windowEl = root.querySelector('[data-window]');
    var quote = root.querySelector('[data-quote]');
    var requireZip = root.hasAttribute('data-require-zip');
    var zipOk = !requireZip;
    var zipChecked = false;
    var current = null;

    // Chips replace the select when JS runs; the select stays as the no-JS fallback.
    if (root.querySelector('[data-option]') && select) select.classList.add('js-hidden');

    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option]'), function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function findVariant() {
      var opts = selectedOptions();
      if (!opts.length) {
        var id = select ? Number(select.value) : 0;
        return variants.filter(function (v) { return v.id === id; })[0] || variants[0] || null;
      }
      return variants.filter(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      })[0] || null;
    }

    function setSpec(field, val) {
      var li = root.querySelector('[data-spec-field="' + field + '"]');
      if (!li) return;
      li.hidden = !val;
      var span = li.querySelector('span');
      if (span) span.textContent = val || '';
    }

    function update() {
      current = findVariant();
      var text = '';
      var enable = true;
      if (!current) {
        enable = false; text = root.getAttribute('data-msg-none');
      } else {
        if (select) select.value = String(current.id);
        if (price) price.textContent = current.price;
        ['option1', 'height_range', 'caliper', 'form', 'sku'].forEach(function (f) { setSpec(f, current[f]); });
        if (windowEl) windowEl.textContent = current.lead_time || root.getAttribute('data-window-default') || '';
        if (quote) {
          quote.hidden = !current.quote;
          try {
            var qurl = new URL(quote.getAttribute('href'), window.location.origin);
            qurl.searchParams.set('size', current.title || '');
            quote.setAttribute('href', qurl.pathname + qurl.search);
          } catch (e) { /* keep the server-rendered link */ }
        }
        if (current.quote) { enable = false; text = root.getAttribute('data-msg-quote'); }
        else if (!current.available) { enable = false; text = root.getAttribute('data-msg-out'); }
        else if (!zipOk) { enable = false; text = root.getAttribute(zipChecked ? 'data-msg-nozip' : 'data-msg-zip'); }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', current.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      if (atc) atc.disabled = !enable;
      if (msg) msg.textContent = text || '';
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option]') || e.target === select) update();
    });
    root.addEventListener('ttr:zip', function (e) {
      zipChecked = true;
      zipOk = !requireZip || !!(e.detail && e.detail.metro);
      update();
    });
    update();
  });
})();
